import { render, staticRenderFns } from "./ShortTripSearch.vue?vue&type=template&id=bef91ac2&"
import script from "./ShortTripSearch.vue?vue&type=script&lang=js&"
export * from "./ShortTripSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports